import angular from 'angular';

import { megaNumber } from './megaNumber';
import { tel } from './tel';

export default angular
  .module('est.filters', [])
  .filter('megaNumber', [() => megaNumber])
  .filter('tel', [() => tel])
  .filter('sanitize', [
    '$sce',
    function ($sce: angular.ISCEService) {
      return function (htmlCode: string) {
        return $sce.trustAsHtml(htmlCode);
      };
    },
  ]);
